import useSWR from 'swr'
import { defaultState } from '../fetchChannel'
import convertMinutesToMilliseconds from '../convertMinutesToMilliseconds'
import useGigIDs from '../useGigIDs'

/** Will pass the initial state from the PageContent object, then revalidate. Subsequent calls won't need to pass initial state as it will be cached */
const useChannel = (initialData = defaultState, hostUrl = '') => {

  const { channelId } = useGigIDs()

  return useSWR(channelId ? [ 'channel', hostUrl, '', channelId ] : null, {
    onErrorRetry: (error, key, config, revalidate, { retryCount }) => {

      if (error.status === 404) return

      // Retry every minute on failure
      setTimeout(() => revalidate({ retryCount: retryCount + 1 }), convertMinutesToMilliseconds(2))

    },
    initialData,
    revalidateOnMount: true,
    revalidateOnFocus: false
  })

}

export default useChannel
